import type { CatalogProduct, MinorMoney } from "./types";

const fractionDigits = new Map<string, number>();

export function currencyFractionDigits(currency: string): number {
  const cached = fractionDigits.get(currency);
  if (cached !== undefined) return cached;
  const digits = new Intl.NumberFormat("en", { style: "currency", currency }).resolvedOptions().maximumFractionDigits ?? 2;
  fractionDigits.set(currency, digits);
  return digits;
}

export function formatMinorMoney(money: MinorMoney, locale = "en-IE"): string {
  if (!Number.isSafeInteger(money.amount) || money.amount < 0 || !/^[A-Z]{3}$/u.test(money.currency)) return "Price unavailable";
  const divisor = 10 ** currencyFractionDigits(money.currency);
  return new Intl.NumberFormat(locale, { style: "currency", currency: money.currency, currencyDisplay: "symbol" }).format(money.amount / divisor);
}

export function sumByCurrency(lines: readonly { money: MinorMoney; quantity?: number }[]): readonly MinorMoney[] {
  const totals = new Map<string, number>();
  for (const line of lines) {
    const quantity = line.quantity ?? 1;
    if (!Number.isSafeInteger(quantity) || quantity < 1) continue;
    totals.set(line.money.currency, (totals.get(line.money.currency) ?? 0) + line.money.amount * quantity);
  }
  return [...totals].map(([currency, amount]) => ({ currency, amount }));
}

export function primaryPrice(product: CatalogProduct): MinorMoney | undefined {
  return product.variants[0]?.price;
}
